/**
 * LEADS-LIST-SALESFORCE-VIEWS-V1 -- the Leads list FILTER PANEL (the
 * Salesforce right-side discipline): the former inline filter bar moves into
 * a collapsible right-side panel opened by a "Filters" button, so the list
 * grammar reads clean by default and the applied state summarizes as
 * removable tokens above the table.
 *
 * COMPOSITION ONLY, ZERO FENCE CHANGE. It renders the caller's EXISTING,
 * role-shaped FilterBar groups BYTE-IDENTICALLY (same FilterGroupDef set,
 * same handlers -- an agent still never gains an All/Anyone control, because
 * the server already shaped the groups). It reuses the ONE drawer shell
 * (DrawerShell -- the same scrim / Escape / focus-seed the LeadQuickView
 * drawer uses) so the panel matches the quick view by construction. Every
 * filter still only writes URL state; the SERVER shapes data + options.
 */

import { DrawerShell, FilterBar, type FilterGroupDef, type FilterBarProps } from '@/dashboard/ui';

export interface LeadFilterPanelProps {
  readonly groups: readonly FilterGroupDef[];
  readonly onToggleToken: FilterBarProps['onToggleToken'];
  readonly onChoice: FilterBarProps['onChoice'];
  readonly onFlag: FilterBarProps['onFlag'];
  readonly onReset: FilterBarProps['onReset'];
  /** Number of active filter tokens (for the panel header count). */
  readonly activeCount: number;
  readonly onClose: () => void;
}

export default function LeadFilterPanel({
  groups,
  onToggleToken,
  onChoice,
  onFlag,
  onReset,
  activeCount,
  onClose,
}: LeadFilterPanelProps): JSX.Element {
  return (
    <DrawerShell
      eyebrow="Refine the list"
      title={activeCount > 0 ? `Filters (${activeCount})` : 'Filters'}
      onClose={onClose}
      testId="lead-filter-panel"
    >
      <div className="lead-filter-panel">
        <p className="lead-filter-panel__note">
          Filters run on the server within your verified scope. Applied filters show as
          removable tokens above the table.
        </p>
        <FilterBar
          groups={groups}
          onToggleToken={onToggleToken}
          onChoice={onChoice}
          onFlag={onFlag}
          onReset={onReset}
        />
      </div>
    </DrawerShell>
  );
}
